import { css, htmlArray } from "../helpers/webComponents";
import { GameRouteService } from "../services/GameRouteService";

const mapStyles: string = css`
:host {
    display: block;
    text-align: left;
    z-index: 1000;
}

.map-button {
    margin-top: 35px;
    background-color: #075398;
    color: white;
    border: none;
    padding: 19px;
    font-family: "Onesize", Arial, sans-serif;
    font-size: 18px;
    cursor: pointer;
    text-transform: uppercase;
    border-radius: 15px;
    position: absolute;
    left: 95%;
    white-space: nowrap;
}

.room-label {
    position: absolute;
    top: 105px;
    left: 74%;
    background-color: black;
    padding: 13px;
    border-radius: 10px;
    font-weight: bold;
    white-space: nowrap;
}
`;

export class MapComponent extends HTMLElement {
    private readonly _gameRouteService: GameRouteService = new GameRouteService();
    private currentRoom: string = "Loading...";

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        void this.fetchCurrentRoom();
        this.render();
    }

    private async fetchCurrentRoom(): Promise<void> {
        try {
            this.currentRoom = await this._gameRouteService.getCurrentRoom();
            this.render();
        }
        catch (error) {
            console.error("Failed to fetch current room", error);
        }
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const elements: HTMLElement[] = htmlArray`
            <style>${mapStyles}</style>
            <button class="map-button">Check the Map</button>
            <div class="room-label">Current Room: ${this.currentRoom}</div>
        `;

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);
        const button: HTMLButtonElement | null = this.shadowRoot.querySelector(".map-button");
        const roomLabel: HTMLDivElement | null = this.shadowRoot.querySelector(".room-label");
        if (!roomLabel) {
            console.error("Room label not found");
            return;
        }
        if (!button) {
            console.error("Button not found");
            return;
        }
        roomLabel.style.display = "none";
        button.addEventListener("click", () => {
            roomLabel.style.display = roomLabel.style.display === "none" ? "block" : "none";
        });
    }
}
